export default "__VITE_ASSET__Cd7DM3Jn__"